"use strict";

const isValidInvoiceQrFlag = value =>
  [true, false, 1, 0, "1", "0", "true", "false"].includes(value);

function normalizeInvoiceQrFlag(value, fallback = true) {
  if (!isValidInvoiceQrFlag(value)) return Boolean(fallback);
  return value === true || value === 1 || value === "1" || value === "true";
}

const isInvoiceQrEnabled = warehouse => normalizeInvoiceQrFlag(warehouse?.show_qr_code_on_invoice);

module.exports = { isValidInvoiceQrFlag, normalizeInvoiceQrFlag, isInvoiceQrEnabled };
